import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "contact-group" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-phone" })
], -1)
const _hoisted_7 = { class: "detail" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Hotline miễn phí (24/7)", -1)
const _hoisted_9 = { class: "link" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-phone" })
], -1)
const _hoisted_13 = { class: "detail" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Khiếu nại, phản hồi (miễn phí)", -1)
const _hoisted_15 = { class: "link" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-email-open" })
], -1)
const _hoisted_19 = { class: "detail" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Bộ phận kinh doanh", -1)
const _hoisted_21 = { class: "link" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-email-open" })
], -1)
const _hoisted_25 = { class: "detail" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Phòng dự án", -1)
const _hoisted_27 = { class: "link" }
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-email-open" })
], -1)
const _hoisted_31 = { class: "detail" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Chăm sóc khách hàng", -1)
const _hoisted_33 = { class: "link" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "info-container" }
const _hoisted_37 = { class: "address" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("a", {
  class: "logo",
  href: "/",
  title: "Rever"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://s3-cdn.rever.vn/p/v2.42.42/images/rv-logo-ft.svg",
    alt: "rever",
    title: "rever"
  })
], -1)
const _hoisted_39 = { class: "company-name" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-home" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-pin-drop" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-phone" }, null, -1)
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "px-1" }, "-", -1)
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-email" }, null, -1)
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("a", {
  class: "gov",
  href: "http://online.gov.vn/Home/WebDetails/84851",
  target: "_blank",
  title: "Bộ công thương"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://s3-cdn.rever.vn/p/v2.42.42/images/logoSaleNoti.png",
    alt: "Công ty Cổ Phần Công Nghệ Rever"
  })
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "link-cty" }, [
  /*#__PURE__*/_createTextVNode("CÔNG TY"),
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi col-toggle zmdi-chevron-down" })
], -1)
const _hoisted_50 = { id: "mn-01" }
const _hoisted_51 = ["href"]
const _hoisted_52 = ["href"]
const _hoisted_53 = ["href"]
const _hoisted_54 = ["href"]
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href"]
const _hoisted_57 = ["href"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", { class: "link-dv" }, [
  /*#__PURE__*/_createTextVNode("DỊCH VỤ"),
  /*#__PURE__*/_createElementVNode("i", { class: "zmdi col-toggle zmdi-chevron-down" })
], -1)
const _hoisted_59 = { id: "mn-02" }
const _hoisted_60 = ["href"]
const _hoisted_61 = ["href"]
const _hoisted_62 = ["href"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://academy.rever.vn",
    title: "Rever Academy"
  }, "Rever Academy")
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://agent.rever.vn",
    title: "Rever Agents"
  }, "Rever Agents")
], -1)
const _hoisted_65 = ["href"]
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<li><span class=\"link-tt\">THÔNG TIN<i class=\"zmdi col-toggle zmdi-chevron-down\"></i></span><ul id=\"mn-03\"><li><a href=\"https://blog.rever.vn/topic/thị-trường\" target=\"_blank\" title=\"Tin tức thị trường\">Tin tức thị trường</a></li><li><a href=\"https://blog.rever.vn/topic/phân-tích\" target=\"_blank\" title=\"Báo cáo &amp; phân tích\">Báo cáo &amp; phân tích</a></li><li><a href=\"https://blog.rever.vn/topic/cập-nhật-sản-phẩm\" target=\"_blank\" title=\"Cập nhật sản phẩm\">Cập nhật sản phẩm</a></li><li><a href=\"https://agent.rever.vn/blog\" target=\"_blank\" title=\"Kiến thức cho môi giới\">Kiến thức cho môi giới</a></li></ul></li><li><span class=\"link-ud\">ỨNG DỤNG<i class=\"zmdi col-toggle zmdi-chevron-down\"></i></span><ul id=\"mn-04\"><li><a href=\"https://itunes.apple.com/vn/app/rever/id1101768201\" target=\"_blank\" title=\"Rever trên iOS\">Rever trên iOS</a></li><li><a href=\"https://play.google.com/store/apps/details?id=com.rever.app.android\" target=\"_blank\" title=\"Rever trên Android\">Rever trên Android</a></li></ul></li>", 2)
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "left" }
const _hoisted_70 = /*#__PURE__*/_createStaticVNode("<div class=\"right\"><a href=\"#\">Đánh giá</a><div class=\"social-group\"><a class=\"zmdi zmdi-facebook\" href=\"https://www.facebook.com/rever.vn\" title=\"Facebook Rever\" target=\"_blank\"></a><a class=\"zmdi zmdi-twitter\" href=\"https://twitter.com/VnRever\" title=\"Twitter Rever\" target=\"_blank\"></a><a class=\"zmdi zmdi-linkedin-box\" href=\"https://www.linkedin.com/company/rever-real-estate\" title=\"Linkedin Rever\" target=\"_blank\"></a><a class=\"zmdi zmdi-instagram\" href=\"https://www.instagram.com/rever.vn/\" title=\"Instagram Rever\" target=\"_blank\"></a><a class=\"zmdi zmdi-youtube-play\" href=\"https://www.youtube.com/channel/UCGqD_zho0DQyxXJ3G65NmSQ\" title=\"Youtube Rever\" target=\"_blank\"></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeedbackForm = _resolveComponent("FeedbackForm")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, [
                _createElementVNode("a", {
                  href: `tel: ${_ctx.hotline}`
                }, _toDisplayString(_ctx.hotline), 9, _hoisted_10)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("a", {
                  href: `tel: ${_ctx.feedbackHotline}`
                }, _toDisplayString(_ctx.feedbackHotline), 9, _hoisted_16)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("p", _hoisted_21, [
                _createElementVNode("a", {
                  href: `mailto:${_ctx.saleEmail}`
                }, _toDisplayString(_ctx.saleEmail), 9, _hoisted_22)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("p", _hoisted_27, [
                _createElementVNode("a", {
                  href: `mailto:${_ctx.productEmail}`
                }, _toDisplayString(_ctx.productEmail), 9, _hoisted_28)
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("p", _hoisted_33, [
                _createElementVNode("a", {
                  href: `mailto:${_ctx.supportEmail}`
                }, _toDisplayString(_ctx.supportEmail), 9, _hoisted_34)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("ul", _hoisted_36, [
          _createElementVNode("li", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.reverTechCompanyName), 1),
            _createElementVNode("p", null, [
              _hoisted_40,
              _createTextVNode("MST: " + _toDisplayString(_ctx.reverMst) + " - Sở KHĐT TP Hồ Chí Minh cấp ngày 20/05/2016", 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_41,
              _createTextVNode(_toDisplayString(_ctx.address), 1)
            ]),
            _createElementVNode("p", null, [
              _hoisted_42,
              _createElementVNode("a", {
                href: `tel: ${_ctx.hotlineOffice}`
              }, _toDisplayString(_ctx.hotlineOffice), 9, _hoisted_43),
              _hoisted_44,
              _createElementVNode("a", {
                href: `tel: ${_ctx.hotline}`
              }, _toDisplayString(_ctx.hotline), 9, _hoisted_45)
            ]),
            _createElementVNode("p", null, [
              _hoisted_46,
              _createElementVNode("a", {
                href: `mailto:${_ctx.supportEmail}`
              }, _toDisplayString(_ctx.supportEmail), 9, _hoisted_47)
            ]),
            _hoisted_48
          ]),
          _createElementVNode("li", null, [
            _hoisted_49,
            _createElementVNode("ul", _hoisted_50, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/gioi-thieu`,
                  title: "Về Rever"
                }, "Về Rever", 8, _hoisted_51)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/tuyen-dung`,
                  title: "Tuyển dụng"
                }, "Tuyển dụng", 8, _hoisted_52)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/doi-ngu`,
                  title: "Đội ngũ"
                }, "Đội ngũ", 8, _hoisted_53)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/san-giao-dich`,
                  title: "Sàn giao dịch"
                }, "Sàn giao dịch", 8, _hoisted_54)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/lien-he`,
                  title: "Liên hệ"
                }, "Liên hệ", 8, _hoisted_55)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/chinh-sach-bao-mat`,
                  title: "Chính sách bảo mật"
                }, "Chính sách bảo mật", 8, _hoisted_56)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/dieu-khoan-su-dung`,
                  title: "Điều khoản sử dụng"
                }, "Điều khoản sử dụng", 8, _hoisted_57)
              ])
            ])
          ]),
          _createElementVNode("li", null, [
            _hoisted_58,
            _createElementVNode("ul", _hoisted_59, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/ban-nha-voi-rever`,
                  title: "Bán & Cho thuê"
                }, "Bán & Cho thuê", 8, _hoisted_60)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/mua-nha-voi-rever`,
                  title: "Mua với Rever"
                }, "Mua với Rever", 8, _hoisted_61)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/thue-nha-voi-rever`,
                  title: "Thuê với Rever"
                }, "Thuê với Rever", 8, _hoisted_62)
              ]),
              _hoisted_63,
              _hoisted_64,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: `${_ctx.reverWebUrl}/quy-trinh-dich-vu`,
                  title: "Quy trình dịch vụ"
                }, "Quy trình dịch vụ", 8, _hoisted_65)
              ])
            ])
          ]),
          _hoisted_66
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("span", null, "Copyright © " + _toDisplayString(_ctx.currentYear) + " - Rever. All Rights Reserved.", 1)
        ]),
        _hoisted_70
      ])
    ]),
    _createVNode(_component_FeedbackForm, { ref: "feedbackForm" }, null, 512)
  ]))
}